var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 74,
    viewBox: "0 0 68 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3255 25.7774C30.2685 27.3878 34.7323 29.164 40.9109 29.926C42.8085 30.1603 44.6245 30.2792 46.3086 30.2792C47.0768 30.2792 47.802 30.2549 48.4871 30.2102C48.3874 33.0541 48.0062 36.6136 46.9966 40.4855C44.1092 51.5586 37.499 60.4418 27.3257 66.9359C17.1515 60.4417 10.5407 51.5584 7.65297 40.4854C6.64323 36.6134 6.26197 33.0541 6.16226 30.2102C6.84715 30.2549 7.57264 30.2792 8.34074 30.2792C10.0248 30.2792 11.8407 30.1604 13.7372 29.9262C19.9176 29.1641 24.382 27.3879 27.3255 25.7774ZM27.3258 18.605C27.3258 18.605 23.028 22.8709 12.9536 24.1131C11.2011 24.3296 9.67141 24.4181 8.34068 24.4181C2.35022 24.4181 0.400497 22.6234 0.400497 22.6234C0.400497 22.6234 -5.42101 55.6735 27.3258 73.8356C60.0702 55.6734 54.2489 22.6234 54.2489 22.6234C54.2489 22.6234 52.3002 24.4181 46.3086 24.4181C44.9781 24.4181 43.4475 24.3295 41.6956 24.1131C31.6228 22.8709 27.3258 18.605 27.3258 18.605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2276 33.0916L23.3482 49.236L16.6657 42.8445L12.0234 47.2841L23.3482 58.1155L44.8695 37.5316L40.2276 33.0916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7552 25.3655C30.6982 26.976 35.162 28.7522 41.3405 29.5142C43.2382 29.7485 45.0542 29.8674 46.7382 29.8674C47.5065 29.8674 48.2317 29.8431 48.9168 29.7984C48.8171 32.6423 48.4359 36.2017 47.4263 40.0737C44.5389 51.1468 37.9287 60.03 27.7554 66.5241C17.5812 60.0299 10.9704 51.1466 8.08266 40.0736C7.07292 36.2016 6.69166 32.6423 6.59195 29.7984C7.27684 29.8431 8.00233 29.8674 8.77043 29.8674C10.4544 29.8674 12.2704 29.7486 14.1669 29.5143C20.3474 28.7522 24.8117 26.9761 27.7552 25.3655ZM27.7555 18.1931C27.7555 18.1931 23.4577 22.459 13.3833 23.7013C11.6308 23.9177 10.1011 24.0062 8.77037 24.0062C2.77991 24.0062 0.830185 22.2116 0.830185 22.2116C0.830185 22.2116 -4.99132 55.2616 27.7555 73.4237C60.4999 55.2616 54.6785 22.2116 54.6785 22.2116C54.6785 22.2116 52.7298 24.0062 46.7382 24.0062C45.4078 24.0062 43.8772 23.9176 42.1253 23.7013C32.0525 22.4591 27.7555 18.1931 27.7555 18.1931Z",
    fill: "url(#paint0_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6573 32.6797L23.7778 48.8242L17.0954 42.4326L12.4531 46.8723L23.7778 57.7037L45.2992 37.1198L40.6573 32.6797Z",
    fill: "url(#paint1_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1849 24.9536C31.1279 26.5641 35.5917 28.3403 41.7702 29.1023C43.6679 29.3366 45.4839 29.4554 47.1679 29.4554C47.9362 29.4554 48.6614 29.4312 49.3465 29.3865C49.2468 32.2303 48.8656 35.7898 47.856 39.6618C44.9686 50.7349 38.3584 59.618 28.1851 66.1121C18.0109 59.618 11.4 50.7347 8.51235 39.6617C7.50261 35.7897 7.12135 32.2303 7.02163 29.3865C7.70652 29.4312 8.43201 29.4554 9.20011 29.4554C10.8842 29.4554 12.7001 29.3366 14.5966 29.1024C20.7771 28.3404 25.2414 26.5642 28.1849 24.9536ZM28.1852 17.7812C28.1852 17.7812 23.8874 22.0472 13.813 23.2894C12.0605 23.5058 10.5308 23.5943 9.20005 23.5943C3.20959 23.5943 1.25987 21.7997 1.25987 21.7997C1.25987 21.7997 -4.56164 54.8497 28.1852 73.0119C60.9296 54.8497 55.1082 21.7997 55.1082 21.7997C55.1082 21.7997 53.1595 23.5943 47.1679 23.5943C45.8375 23.5943 44.3069 23.5057 42.555 23.2894C32.4822 22.0472 28.1852 17.7812 28.1852 17.7812Z",
    fill: "url(#paint2_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.087 32.2678L24.2075 48.4123L17.5251 42.0207L12.8828 46.4604L24.2075 57.2919L45.7289 36.7079L41.087 32.2678Z",
    fill: "url(#paint3_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6185 24.5418C31.5615 26.1522 36.0253 27.9284 42.2038 28.6904C44.1015 28.9247 45.9175 29.0436 47.6015 29.0436C48.3698 29.0436 49.095 29.0193 49.7801 28.9745C49.6804 31.8185 49.2992 35.3779 48.2896 39.2498C45.4022 50.3229 38.792 59.2061 28.6187 65.7002C18.4445 59.2061 11.8336 50.3228 8.94594 39.2497C7.9362 35.3778 7.55494 31.8184 7.45523 28.9745C8.14012 29.0193 8.86561 29.0436 9.63371 29.0436C11.3177 29.0436 13.1337 28.9247 15.0302 28.6905C21.2106 27.9285 25.675 26.1523 28.6185 24.5418ZM28.6188 17.3694C28.6188 17.3694 24.321 21.6354 14.2466 22.8775C12.4941 23.094 10.9644 23.1825 9.63365 23.1825C3.64319 23.1825 1.69347 21.3879 1.69347 21.3879C1.69347 21.3879 -4.12804 54.4379 28.6188 72.6001C61.3632 54.4379 55.5418 21.3879 55.5418 21.3879C55.5418 21.3879 53.5931 23.1825 47.6015 23.1825C46.2711 23.1825 44.7405 23.0939 42.9885 22.8775C32.9158 21.6353 28.6188 17.3694 28.6188 17.3694Z",
    fill: "url(#paint4_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5206 31.856L24.6411 48.0004L17.9587 41.6089L13.3164 46.0486L24.6411 56.88L46.1624 36.296L41.5206 31.856Z",
    fill: "url(#paint5_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0481 24.1299C31.9911 25.7404 36.4549 27.5166 42.6335 28.2785C44.5311 28.5129 46.3471 28.6317 48.0312 28.6317C48.7994 28.6317 49.5246 28.6075 50.2097 28.5627C50.11 31.4066 49.7288 34.9661 48.7192 38.838C45.8318 49.9111 39.2217 58.7943 29.0483 65.2884C18.8742 58.7942 12.2633 49.911 9.37557 38.8379C8.36583 34.966 7.98457 31.4066 7.88486 28.5627C8.56975 28.6075 9.29524 28.6317 10.0633 28.6317C11.7474 28.6317 13.5634 28.5129 15.4598 28.2787C21.6402 27.5166 26.1046 25.7404 29.0481 24.1299ZM29.0484 16.9575C29.0484 16.9575 24.7506 21.2234 14.6763 22.4657C12.9238 22.6821 11.3941 22.7706 10.0633 22.7706C4.07288 22.7706 2.12315 20.976 2.12315 20.976C2.12315 20.976 -3.69836 54.026 29.0485 72.1881C61.7928 54.026 55.9715 20.976 55.9715 20.976C55.9715 20.976 54.0228 22.7706 48.0312 22.7706C46.7008 22.7706 45.1702 22.682 43.4182 22.4657C33.3454 21.2234 29.0484 16.9575 29.0484 16.9575Z",
    fill: "url(#paint6_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9503 31.4441L25.0708 47.5886L18.3883 41.197L13.7461 45.6367L25.0708 56.4681L46.5921 35.8841L41.9503 31.4441Z",
    fill: "url(#paint7_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4778 23.7178C32.4208 25.3283 36.8846 27.1045 43.0632 27.8664C44.9608 28.1007 46.7768 28.2196 48.4609 28.2196C49.2292 28.2196 49.9544 28.1953 50.6394 28.1506C50.5398 30.9945 50.1586 34.5539 49.1489 38.4259C46.2615 49.499 39.6514 58.3821 29.4781 64.8762C19.3039 58.3821 12.693 49.4988 9.80532 38.4258C8.79558 34.5539 8.41432 30.9944 8.3146 28.1506C8.99949 28.1953 9.72498 28.2196 10.4931 28.2196C12.1771 28.2196 13.9931 28.1007 15.8896 27.8665C22.07 27.1045 26.5344 25.3284 29.4778 23.7178ZM29.4782 16.5454C29.4782 16.5454 25.1803 20.8113 15.106 22.0536C13.3535 22.27 11.8238 22.3585 10.4931 22.3585C4.50262 22.3585 2.55284 20.5639 2.55284 20.5639C2.55284 20.5639 -3.26867 53.6139 29.4782 71.7761C62.2225 53.6139 56.4012 20.5639 56.4012 20.5639C56.4012 20.5639 54.4525 22.3585 48.4609 22.3585C47.1305 22.3585 45.5999 22.2699 43.8479 22.0536C33.7751 20.8114 29.4782 16.5454 29.4782 16.5454Z",
    fill: "url(#paint8_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.38 31.032L25.5005 47.1765L18.818 40.7849L14.1758 45.2246L25.5005 56.056L47.0219 35.4721L42.38 31.032Z",
    fill: "url(#paint9_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9114 23.3059C32.8544 24.9164 37.3182 26.6926 43.4968 27.4546C45.3944 27.6889 47.2104 27.8077 48.8945 27.8077C49.6628 27.8077 50.388 27.7835 51.073 27.7387C50.9734 30.5826 50.5922 34.1421 49.5825 38.014C46.6951 49.0871 40.085 57.9702 29.9116 64.4644C19.7375 57.9702 13.1266 49.0869 10.2389 38.0139C9.22917 34.142 8.84791 30.5826 8.7482 27.7387C9.43309 27.7834 10.1586 27.8077 10.9267 27.8077C12.6107 27.8077 14.4267 27.6889 16.3232 27.4547C22.5036 26.6926 26.9679 24.9165 29.9114 23.3059ZM29.9118 16.1335C29.9118 16.1335 25.6139 20.3995 15.5395 21.6417C13.7871 21.8581 12.2574 21.9466 10.9266 21.9466C4.93616 21.9466 2.98643 20.152 2.98643 20.152C2.98643 20.152 -2.83507 53.202 29.9118 71.3642C62.6561 53.202 56.8348 20.152 56.8348 20.152C56.8348 20.152 54.8861 21.9466 48.8945 21.9466C47.564 21.9466 46.0335 21.858 44.2815 21.6417C34.2087 20.3995 29.9118 16.1335 29.9118 16.1335Z",
    fill: "url(#paint10_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8136 30.6201L25.9341 46.7646L19.2517 40.373L14.6094 44.8127L25.9341 55.6441L47.4555 35.0602L42.8136 30.6201Z",
    fill: "url(#paint11_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.341 22.8941C33.284 24.5045 37.7479 26.2807 43.9264 27.0427C45.8241 27.277 47.6401 27.3959 49.3241 27.3959C50.0924 27.3959 50.8176 27.3716 51.5027 27.3268C51.403 30.1708 51.0218 33.7302 50.0122 37.6021C47.1248 48.6752 40.5146 57.5583 30.3413 64.0525C20.1671 57.5583 13.5562 48.6751 10.6685 37.602C9.6588 33.7301 9.27754 30.1707 9.17783 27.3268C9.86272 27.3716 10.5882 27.3959 11.3563 27.3959C13.0404 27.3959 14.8563 27.277 16.7528 27.0428C22.9333 26.2808 27.3976 24.5046 30.341 22.8941ZM30.3414 15.7217C30.3414 15.7217 26.0436 19.9876 15.9692 21.2298C14.2167 21.4463 12.687 21.5348 11.3563 21.5348C5.36584 21.5348 3.41612 19.7401 3.41612 19.7401C3.41612 19.7401 -2.40539 52.7902 30.3415 70.9523C63.0858 52.7901 57.2645 19.7401 57.2645 19.7401C57.2645 19.7401 55.3158 21.5348 49.3242 21.5348C47.9937 21.5348 46.4631 21.4462 44.7112 21.2298C34.6384 19.9876 30.3414 15.7217 30.3414 15.7217Z",
    fill: "url(#paint12_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2433 30.2083L26.3638 46.3527L19.6814 39.9612L15.0391 44.4009L26.3638 55.2323L47.8852 34.6483L43.2433 30.2083Z",
    fill: "url(#paint13_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7708 22.4822C33.7138 24.0927 38.1776 25.8689 44.3562 26.6308C46.2538 26.8651 48.0698 26.984 49.7539 26.984C50.5221 26.984 51.2473 26.9597 51.9324 26.915C51.8327 29.7589 51.4515 33.3183 50.4419 37.1903C47.5545 48.2634 40.9444 57.1465 30.771 63.6406C20.5969 57.1465 13.986 48.2632 11.0983 37.1902C10.0885 33.3182 9.70728 29.7588 9.60757 26.915C10.2925 26.9597 11.0179 26.984 11.786 26.984C13.4701 26.984 15.2861 26.8651 17.1825 26.631C23.3629 25.8689 27.8273 24.0927 30.7708 22.4822ZM30.7711 15.3098C30.7711 15.3098 26.4733 19.5757 16.3989 20.818C14.6464 21.0344 13.1167 21.1229 11.786 21.1229C5.79553 21.1229 3.84581 19.3283 3.84581 19.3283C3.84581 19.3283 -1.9757 52.3783 30.7711 70.5404C63.5155 52.3782 57.6942 19.3283 57.6942 19.3283C57.6942 19.3283 55.7455 21.1229 49.7539 21.1229C48.4235 21.1229 46.8929 21.0343 45.1409 20.818C35.0681 19.5757 30.7711 15.3098 30.7711 15.3098Z",
    fill: "url(#paint14_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6729 29.7964L26.7934 45.9409L20.111 39.5493L15.4688 43.989L26.7934 54.8204L48.3148 34.2364L43.6729 29.7964Z",
    fill: "url(#paint15_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2005 22.0701C34.1434 23.6806 38.6073 25.4568 44.7859 26.2188C46.6835 26.4531 48.4995 26.5719 50.1836 26.5719C50.9518 26.5719 51.677 26.5477 52.3621 26.5029C52.2624 29.3468 51.8812 32.9063 50.8716 36.7782C47.9842 47.8513 41.3741 56.7344 31.2007 63.2286C21.0266 56.7344 14.4157 47.8511 11.528 36.7781C10.5182 32.9062 10.137 29.3468 10.0373 26.5029C10.7221 26.5476 11.4476 26.5719 12.2157 26.5719C13.8997 26.5719 15.7158 26.4531 17.6122 26.2189C23.7927 25.4568 28.257 23.6807 31.2005 22.0701ZM31.2008 14.8977C31.2008 14.8977 26.903 19.1636 16.8287 20.4059C15.0762 20.6223 13.5465 20.7108 12.2157 20.7108C6.22528 20.7108 4.2755 18.9162 4.2755 18.9162C4.2755 18.9162 -1.54601 51.9662 31.2008 70.1283C63.9452 51.9661 58.1239 18.9162 58.1239 18.9162C58.1239 18.9162 56.1752 20.7108 50.1836 20.7108C48.8531 20.7108 47.3225 20.6222 45.5706 20.4059C35.4978 19.1637 31.2008 14.8977 31.2008 14.8977Z",
    fill: "url(#paint16_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1026 29.3843L27.2232 45.5288L20.5407 39.1372L15.8984 43.5769L27.2232 54.4083L48.7445 33.8244L44.1026 29.3843Z",
    fill: "url(#paint17_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.634 21.6582C34.577 23.2687 39.0408 25.0449 45.2194 25.8069C47.117 26.0412 48.9331 26.16 50.6171 26.16C51.3854 26.16 52.1106 26.1358 52.7956 26.091C52.696 28.9349 52.3148 32.4944 51.3051 36.3663C48.4177 47.4394 41.8076 56.3225 31.6343 62.8167C21.4601 56.3225 14.8492 47.4392 11.9615 36.3662C10.9518 32.4943 10.5705 28.9349 10.4708 26.091C11.1557 26.1357 11.8812 26.16 12.6493 26.16C14.3333 26.16 16.1493 26.0412 18.0458 25.807C24.2262 25.0449 28.6905 23.2688 31.634 21.6582ZM31.6344 14.4858C31.6344 14.4858 27.3366 18.7518 17.2622 19.994C15.5097 20.2104 13.98 20.2989 12.6493 20.2989C6.65882 20.2989 4.7091 18.5044 4.7091 18.5044C4.7091 18.5044 -1.11247 51.5543 31.6344 69.7165C64.3787 51.5543 58.5574 18.5044 58.5574 18.5044C58.5574 18.5044 56.6087 20.2989 50.6171 20.2989C49.2867 20.2989 47.7561 20.2103 46.0041 19.994C35.9314 18.7518 31.6344 14.4858 31.6344 14.4858Z",
    fill: "url(#paint18_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5362 28.9724L27.6568 45.117L20.9743 38.7253L16.332 43.165L27.6568 53.9964L49.1781 33.4125L44.5362 28.9724Z",
    fill: "url(#paint19_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0638 21.2464C35.0068 22.8568 39.4706 24.633 45.6491 25.395C47.5468 25.6293 49.3628 25.7482 51.0468 25.7482C51.8151 25.7482 52.5403 25.7239 53.2254 25.6791C53.1257 28.5231 52.7445 32.0825 51.7349 35.9544C48.8475 47.0275 42.2373 55.9106 32.064 62.4048C21.8898 55.9106 15.2789 47.0274 12.3913 35.9543C11.3815 32.0824 11.0003 28.523 10.9005 25.6791C11.5854 25.7239 12.3109 25.7482 13.079 25.7482C14.763 25.7482 16.579 25.6293 18.4755 25.3951C24.656 24.6331 29.1203 22.8569 32.0638 21.2464ZM32.0641 14.074C32.0641 14.074 27.7663 18.3399 17.6919 19.5821C15.9395 19.7986 14.4098 19.8871 13.079 19.8871C7.08856 19.8871 5.13878 18.0924 5.13878 18.0924C5.13878 18.0924 -0.682729 51.1425 32.0641 69.3046C64.8085 51.1424 58.9871 18.0924 58.9871 18.0924C58.9871 18.0924 57.0384 19.8871 51.0469 19.8871C49.7164 19.8871 48.1858 19.7985 46.4339 19.5821C36.3611 18.3399 32.0641 14.074 32.0641 14.074Z",
    fill: "url(#paint20_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9659 28.5605L28.0864 44.705L21.404 38.3134L16.7617 42.7532L28.0864 53.5846L49.6078 33.0006L44.9659 28.5605Z",
    fill: "url(#paint21_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4935 20.8345C35.4365 22.445 39.9003 24.2212 46.0789 24.9831C47.9765 25.2174 49.7925 25.3363 51.4766 25.3363C52.2449 25.3363 52.9701 25.312 53.6551 25.2673C53.5555 28.1112 53.1743 31.6706 52.1646 35.5426C49.2772 46.6157 42.6671 55.4988 32.4937 61.9929C22.3196 55.4988 15.7087 46.6155 12.821 35.5425C11.8113 31.6706 11.43 28.1111 11.3303 25.2673C12.0152 25.312 12.7407 25.3363 13.5088 25.3363C15.1928 25.3363 17.0088 25.2174 18.9052 24.9832C25.0856 24.2212 29.55 22.445 32.4935 20.8345ZM32.4938 13.6621C32.4938 13.6621 28.196 17.928 18.1216 19.1703C16.3691 19.3867 14.8394 19.4752 13.5087 19.4752C7.51824 19.4752 5.56847 17.6806 5.56847 17.6806C5.56847 17.6806 -0.253042 50.7306 32.4938 68.8928C65.2382 50.7306 59.4168 17.6806 59.4168 17.6806C59.4168 17.6806 57.4681 19.4752 51.4766 19.4752C50.1461 19.4752 48.6155 19.3866 46.8636 19.1703C36.7908 17.928 32.4938 13.6621 32.4938 13.6621Z",
    fill: "url(#paint22_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3956 28.1487L28.5161 44.2932L21.8337 37.9016L17.1914 42.3412L28.5161 53.1727L50.0374 32.5887L45.3956 28.1487Z",
    fill: "url(#paint23_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9232 20.4226C35.8662 22.033 40.33 23.8092 46.5086 24.5712C48.4062 24.8055 50.2222 24.9244 51.9063 24.9244C52.6745 24.9244 53.3997 24.9001 54.0848 24.8554C53.9851 27.6993 53.6039 31.2587 52.5943 35.1307C49.7069 46.2037 43.0968 55.0869 32.9234 61.581C22.7493 55.0869 16.1384 46.2036 13.2507 35.1305C12.2409 31.2586 11.8597 27.6992 11.76 24.8554C12.4449 24.9001 13.1704 24.9244 13.9384 24.9244C15.6224 24.9244 17.4384 24.8055 19.3349 24.5713C25.5154 23.8093 29.9797 22.0332 32.9232 20.4226ZM32.9235 13.2502C32.9235 13.2502 28.6257 17.5162 18.5513 18.7584C16.7988 18.9748 15.2691 19.0633 13.9384 19.0633C7.94793 19.0633 5.99815 17.2687 5.99815 17.2687C5.99815 17.2687 0.176644 50.3187 32.9235 68.4809C65.6679 50.3187 59.8465 17.2687 59.8465 17.2687C59.8465 17.2687 57.8978 19.0633 51.9063 19.0633C50.5758 19.0633 49.0452 18.9747 47.2933 18.7584C37.2205 17.5162 32.9235 13.2502 32.9235 13.2502Z",
    fill: "url(#paint24_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8253 27.7366L28.9458 43.8811L22.2633 37.4895L17.6211 41.9292L28.9458 52.7606L50.4671 32.1767L45.8253 27.7366Z",
    fill: "url(#paint25_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3567 20.0105C36.2997 21.621 40.7636 23.3972 46.9421 24.1592C48.8397 24.3935 50.6558 24.5123 52.3398 24.5123C53.1081 24.5123 53.8333 24.4881 54.5183 24.4433C54.4187 27.2872 54.0375 30.8467 53.0278 34.7186C50.1404 45.7917 43.5303 54.6748 33.3569 61.169C23.1827 54.6748 16.5719 45.7915 13.6842 34.7185C12.6744 30.8466 12.2932 27.2872 12.1935 24.4433C12.8783 24.488 13.6038 24.5123 14.3719 24.5123C16.056 24.5123 17.8719 24.3935 19.7684 24.1593C25.9489 23.3972 30.4133 21.6211 33.3567 20.0105ZM33.3571 12.8381C33.3571 12.8381 29.0593 17.104 18.9849 18.3463C17.2324 18.5627 15.7027 18.6512 14.372 18.6512C8.38153 18.6512 6.43175 16.8566 6.43175 16.8566C6.43175 16.8566 0.61024 49.9066 33.3571 68.0688C66.1015 49.9066 60.2801 16.8566 60.2801 16.8566C60.2801 16.8566 58.3314 18.6512 52.3399 18.6512C51.0094 18.6512 49.4788 18.5626 47.7269 18.3463C37.6541 17.104 33.3571 12.8381 33.3571 12.8381Z",
    fill: "url(#paint26_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2589 27.3247L29.3794 43.4693L22.6969 37.0777L18.0547 41.5173L29.3794 52.3487L50.9008 31.7648L46.2589 27.3247Z",
    fill: "url(#paint27_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7864 19.5986C36.7294 21.2091 41.1932 22.9853 47.3718 23.7473C49.2694 23.9816 51.0854 24.1005 52.7695 24.1005C53.5377 24.1005 54.263 24.0762 54.948 24.0314C54.8484 26.8754 54.4672 30.4348 53.4575 34.3067C50.5701 45.3798 43.96 54.2629 33.7866 60.7571C23.6125 54.2629 17.0016 45.3797 14.1139 34.3066C13.1042 30.4347 12.7229 26.8753 12.6232 24.0314C13.3081 24.0761 14.0336 24.1005 14.8017 24.1005C16.4857 24.1005 18.3017 23.9816 20.1982 23.7474C26.3786 22.9854 30.843 21.2092 33.7864 19.5986ZM33.7868 12.4263C33.7868 12.4263 29.489 16.6922 19.4146 17.9344C17.6621 18.1509 16.1324 18.2394 14.8017 18.2394C8.81122 18.2394 6.86143 16.4447 6.86143 16.4447C6.86143 16.4447 1.03993 49.4948 33.7868 67.6569C66.5312 49.4947 60.7098 16.4447 60.7098 16.4447C60.7098 16.4447 58.7611 18.2394 52.7696 18.2394C51.4391 18.2394 49.9085 18.1507 48.1566 17.9344C38.0837 16.6922 33.7868 12.4263 33.7868 12.4263Z",
    fill: "url(#paint28_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6886 26.9128L29.8091 43.0573L23.1267 36.6657L18.4844 41.1055L29.8091 51.9369L51.3305 31.3529L46.6886 26.9128Z",
    fill: "url(#paint29_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2162 19.1868C37.1592 20.7973 41.623 22.5735 47.8015 23.3354C49.6992 23.5697 51.5152 23.6886 53.1992 23.6886C53.9675 23.6886 54.6927 23.6643 55.3778 23.6196C55.2781 26.4635 54.8969 30.0229 53.8872 33.8949C50.9998 44.968 44.3897 53.8511 34.2163 60.3452C24.0422 53.8511 17.4313 44.9678 14.5436 33.8948C13.5339 30.0229 13.1526 26.4634 13.0529 23.6196C13.7378 23.6643 14.4633 23.6886 15.2314 23.6886C16.9154 23.6886 18.7314 23.5697 20.6279 23.3355C26.8083 22.5735 31.2727 20.7973 34.2162 19.1868ZM34.2164 12.0144C34.2164 12.0144 29.9187 16.2803 19.8443 17.5226C18.0918 17.739 16.5621 17.8275 15.2314 17.8275C9.2409 17.8275 7.29112 16.0329 7.29112 16.0329C7.29112 16.0329 1.46961 49.0829 34.2164 67.245C66.9609 49.0828 61.1395 16.0329 61.1395 16.0329C61.1395 16.0329 59.1908 17.8275 53.1992 17.8275C51.8688 17.8275 50.3382 17.7389 48.5863 17.5226C38.5135 16.2803 34.2164 12.0144 34.2164 12.0144Z",
    fill: "url(#paint30_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1183 26.501L30.2387 42.6455L23.5563 36.2539L18.9141 40.6935L30.2387 51.525L51.7601 30.941L47.1183 26.501Z",
    fill: "url(#paint31_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6459 18.7749C37.5888 20.3854 42.0527 22.1616 48.2312 22.9236C50.1289 23.1579 51.9449 23.2767 53.6289 23.2767C54.3971 23.2767 55.1224 23.2525 55.8075 23.2077C55.7078 26.0516 55.3266 29.6111 54.3169 33.483C51.4295 44.556 44.8194 53.4392 34.646 59.9334C24.4719 53.4392 17.861 44.5559 14.9733 33.4829C13.9635 29.611 13.5823 26.0516 13.4826 23.2077C14.1675 23.2524 14.893 23.2767 15.6611 23.2767C17.345 23.2767 19.1611 23.1579 21.0575 22.9237C27.2381 22.1616 31.7024 20.3854 34.6459 18.7749ZM34.6461 11.6025C34.6461 11.6025 30.3484 15.8685 20.274 17.1107C18.5215 17.3271 16.9918 17.4156 15.6611 17.4156C9.67059 17.4156 7.72081 15.621 7.72081 15.621C7.72081 15.621 1.8993 48.671 34.6461 66.8332C67.3906 48.671 61.5692 15.621 61.5692 15.621C61.5692 15.621 59.6205 17.4156 53.6289 17.4156C52.2985 17.4156 50.7679 17.327 49.016 17.1107C38.9432 15.8685 34.6461 11.6025 34.6461 11.6025Z",
    fill: "url(#paint32_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5479 26.0891L30.6684 42.2336L23.986 35.842L19.3438 40.2817L30.6684 51.1131L52.1898 30.5292L47.5479 26.0891Z",
    fill: "url(#paint33_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0794 18.3631C38.0224 19.9735 42.4862 21.7497 48.6648 22.5117C50.5624 22.746 52.3784 22.8649 54.0625 22.8649C54.8307 22.8649 55.5559 22.8406 56.241 22.7958C56.1413 25.6398 55.7601 29.1992 54.7505 33.0711C51.863 44.1442 45.2529 53.0273 35.0796 59.5215C24.9054 53.0273 18.2945 44.1441 15.4068 33.071C14.3971 29.1991 14.0158 25.6397 13.9161 22.7958C14.601 22.8406 15.3265 22.8649 16.0946 22.8649C17.7786 22.8649 19.5946 22.746 21.4911 22.5118C27.6716 21.7498 32.1359 19.9736 35.0794 18.3631ZM35.0797 11.1907C35.0797 11.1907 30.7819 15.4566 20.7076 16.6988C18.9551 16.9153 17.4254 17.0038 16.0946 17.0038C10.1042 17.0038 8.1544 15.2092 8.1544 15.2092C8.1544 15.2092 2.33289 48.2592 35.0797 66.4213C67.8242 48.2592 62.0028 15.2092 62.0028 15.2092C62.0028 15.2092 60.0541 17.0038 54.0625 17.0038C52.7321 17.0038 51.2015 16.9152 49.4495 16.6988C39.3767 15.4566 35.0797 11.1907 35.0797 11.1907Z",
    fill: "url(#paint34_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9815 25.6772L31.1021 41.8217L24.4196 35.4302L19.7773 39.8699L31.1021 50.7013L52.6234 30.1174L47.9815 25.6772Z",
    fill: "url(#paint35_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5091 17.9509C38.452 19.5614 42.9159 21.3376 49.0945 22.0996C50.9921 22.3339 52.8081 22.4528 54.4922 22.4528C55.2604 22.4528 55.9857 22.4285 56.6707 22.3837C56.5711 25.2277 56.1899 28.7871 55.1802 32.659C52.2928 43.7321 45.6827 52.6152 35.5093 59.1094C25.3351 52.6152 18.7243 43.732 15.8366 32.6589C14.8268 28.787 14.4456 25.2276 14.3459 22.3837C15.0307 22.4284 15.7562 22.4528 16.5243 22.4528C18.2083 22.4528 20.0243 22.3339 21.9208 22.0997C28.1013 21.3377 32.5657 19.5615 35.5091 17.9509ZM35.5094 10.7786C35.5094 10.7786 31.2116 15.0445 21.1372 16.2867C19.3848 16.5031 17.8551 16.5916 16.5243 16.5916C10.5339 16.5916 8.58409 14.797 8.58409 14.797C8.58409 14.797 2.76258 47.847 35.5094 66.0092C68.2538 47.847 62.4324 14.797 62.4324 14.797C62.4324 14.797 60.4838 16.5916 54.4922 16.5916C53.1618 16.5916 51.6311 16.503 49.8792 16.2867C39.8064 15.0445 35.5094 10.7786 35.5094 10.7786Z",
    fill: "url(#paint36_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4112 25.2651L31.5317 41.4096L24.8493 35.018L20.207 39.4578L31.5317 50.2892L53.0531 29.7052L48.4112 25.2651Z",
    fill: "url(#paint37_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9388 17.5391C38.8818 19.1496 43.3456 20.9257 49.5242 21.6877C51.4218 21.922 53.2378 22.0409 54.9219 22.0409C55.6902 22.0409 56.4154 22.0166 57.1005 21.9719C57.0008 24.8158 56.6196 28.3752 55.6099 32.2472C52.7225 43.3202 46.1124 52.2034 35.939 58.6975C25.7649 52.2034 19.154 43.3201 16.2663 32.2471C15.2566 28.3752 14.8753 24.8157 14.7756 21.9719C15.4605 22.0166 16.186 22.0409 16.9541 22.0409C18.6381 22.0409 20.4541 21.922 22.3506 21.6878C28.531 20.9257 32.9953 19.1496 35.9388 17.5391ZM35.9391 10.3667C35.9391 10.3667 31.6413 14.6326 21.5669 15.8748C19.8145 16.0912 18.2848 16.1797 16.954 16.1797C10.9636 16.1797 9.01378 14.3852 9.01378 14.3852C9.01378 14.3852 3.19227 47.4352 35.9391 65.5973C68.6835 47.4351 62.8621 14.3852 62.8621 14.3852C62.8621 14.3852 60.9134 16.1797 54.9219 16.1797C53.5914 16.1797 52.0608 16.0912 50.3089 15.8748C40.2361 14.6326 35.9391 10.3667 35.9391 10.3667Z",
    fill: "url(#paint38_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8409 24.8533L31.9614 40.9978L25.279 34.6062L20.6367 39.0458L31.9614 49.8773L53.4827 29.2933L48.8409 24.8533Z",
    fill: "url(#paint39_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3685 17.1272C39.3115 18.7376 43.7753 20.5138 49.9539 21.2758C51.8515 21.5101 53.6675 21.629 55.3516 21.629C56.1199 21.629 56.8451 21.6047 57.5302 21.5599C57.4305 24.4039 57.0493 27.9633 56.0396 31.8352C53.1522 42.9083 46.5421 51.7915 36.3687 58.2856C26.1946 51.7915 19.5837 42.9082 16.6961 31.8351C15.6863 27.9632 15.3051 24.4038 15.2053 21.5599C15.8902 21.6047 16.6157 21.629 17.3838 21.629C19.0678 21.629 20.8838 21.5101 22.7803 21.2759C28.9607 20.5139 33.425 18.7377 36.3685 17.1272ZM36.3688 9.95483C36.3688 9.95483 32.071 14.2207 21.9966 15.4629C20.2441 15.6794 18.7144 15.7679 17.3837 15.7679C11.3932 15.7679 9.44347 13.9732 9.44347 13.9732C9.44347 13.9732 3.62196 47.0233 36.3688 65.1855C69.1132 47.0233 63.2918 13.9732 63.2918 13.9732C63.2918 13.9732 61.3431 15.7679 55.3516 15.7679C54.0211 15.7679 52.4905 15.6793 50.7386 15.4629C40.6658 14.2207 36.3688 9.95483 36.3688 9.95483Z",
    fill: "url(#paint40_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2706 24.4414L32.3911 40.5859L25.7087 34.1943L21.0664 38.634L32.3911 49.4654L53.9124 28.8815L49.2706 24.4414Z",
    fill: "url(#paint41_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.802 16.7153C39.7451 18.3258 44.2089 20.102 50.3874 20.8639C52.285 21.0982 54.1011 21.2171 55.7852 21.2171C56.5534 21.2171 57.2786 21.1928 57.9637 21.1481C57.8641 23.992 57.4828 27.5514 56.4732 31.4234C53.5858 42.4964 46.9756 51.3796 36.8023 57.8737C26.6281 51.3796 20.0172 42.4963 17.1295 31.4233C16.1198 27.5514 15.7385 23.9919 15.6388 21.1481C16.3237 21.1928 17.0492 21.2171 17.8172 21.2171C19.5013 21.2171 21.3173 21.0982 23.2137 20.8641C29.3942 20.102 33.8586 18.3259 36.802 16.7153ZM36.8024 9.54297C36.8024 9.54297 32.5045 13.8089 22.4302 15.0511C20.6777 15.2675 19.148 15.356 17.8173 15.356C11.8268 15.356 9.87706 13.5614 9.87706 13.5614C9.87706 13.5614 4.05555 46.6114 36.8024 64.7735C69.5468 46.6113 63.7254 13.5614 63.7254 13.5614C63.7254 13.5614 61.7767 15.356 55.7852 15.356C54.4547 15.356 52.9241 15.2674 51.1722 15.0511C41.0994 13.8088 36.8024 9.54297 36.8024 9.54297Z",
    fill: "url(#paint42_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7042 24.0293L32.8247 40.1738L26.1422 33.7823L21.5 38.2219L32.8247 49.0533L54.346 28.4694L49.7042 24.0293Z",
    fill: "url(#paint43_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2317 16.3035C40.1747 17.914 44.6385 19.6902 50.8171 20.4521C52.7147 20.6864 54.5308 20.8053 56.2149 20.8053C56.9831 20.8053 57.7083 20.781 58.3934 20.7363C58.2937 23.5802 57.9125 27.1396 56.9029 31.0116C54.0154 42.0846 47.4053 50.9678 37.232 57.4619C27.0578 50.9678 20.4469 42.0845 17.5593 31.0115C16.5495 27.1396 16.1683 23.5801 16.0686 20.7363C16.7535 20.781 17.4789 20.8053 18.247 20.8053C19.931 20.8053 21.7471 20.6864 23.6435 20.4522C29.8239 19.6902 34.2883 17.914 37.2317 16.3035ZM37.2321 9.1311C37.2321 9.1311 32.9343 13.397 22.8599 14.6392C21.1074 14.8556 19.5777 14.9441 18.247 14.9441C12.2565 14.9441 10.3067 13.1495 10.3067 13.1495C10.3067 13.1495 4.48524 46.1995 37.2321 64.3617C69.9765 46.1995 64.1551 13.1495 64.1551 13.1495C64.1551 13.1495 62.2064 14.9441 56.2149 14.9441C54.8844 14.9441 53.3538 14.8556 51.6019 14.6392C41.5291 13.397 37.2321 9.1311 37.2321 9.1311Z",
    fill: "url(#paint44_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1339 23.6177L33.2544 39.7622L26.572 33.3706L21.9297 37.8103L33.2544 48.6417L54.7758 28.0578L50.1339 23.6177Z",
    fill: "url(#paint45_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6615 15.8914C40.6045 17.5019 45.0683 19.278 51.2468 20.04C53.1445 20.2743 54.9605 20.3932 56.6446 20.3932C57.4128 20.3932 58.1381 20.3689 58.8231 20.3242C58.7235 23.1681 58.3423 26.7275 57.3326 30.5995C54.4452 41.6725 47.835 50.5557 37.6617 57.0498C27.4875 50.5557 20.8767 41.6724 17.989 30.5993C16.9793 26.7275 16.598 23.168 16.4983 20.3242C17.1832 20.3689 17.9087 20.3932 18.6768 20.3932C20.3608 20.3932 22.1768 20.2743 24.0733 20.0401C30.2536 19.2781 34.718 17.5019 37.6615 15.8914ZM37.6618 8.71899C37.6618 8.71899 33.364 12.9849 23.2896 14.2271C21.5371 14.4435 20.0074 14.532 18.6767 14.532C12.6862 14.532 10.7364 12.7375 10.7364 12.7375C10.7364 12.7375 4.91497 45.7875 37.6618 63.9496C70.4062 45.7874 64.5848 12.7375 64.5848 12.7375C64.5848 12.7375 62.6361 14.532 56.6445 14.532C55.3142 14.532 53.7835 14.4435 52.0316 14.2271C41.9588 12.9849 37.6618 8.71899 37.6618 8.71899Z",
    fill: "url(#paint46_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5636 23.2056L33.684 39.35L27.0016 32.9585L22.3594 37.3981L33.684 48.2296L55.2054 27.6456L50.5636 23.2056Z",
    fill: "url(#paint47_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0912 15.4795C41.0342 17.09 45.498 18.8662 51.6765 19.6282C53.5742 19.8625 55.3902 19.9813 57.0743 19.9813C57.8425 19.9813 58.5678 19.9571 59.2528 19.9123C59.1532 22.7562 58.772 26.3156 57.7623 30.1876C54.8749 41.2606 48.2647 50.1438 38.0914 56.638C27.9172 50.1438 21.3063 41.2605 18.4187 30.1875C17.409 26.3156 17.0277 22.7562 16.928 19.9123C17.6129 19.957 18.3384 19.9813 19.1065 19.9813C20.7905 19.9813 22.6065 19.8625 24.503 19.6283C30.6834 18.8662 35.1477 17.09 38.0912 15.4795ZM38.0914 8.30713C38.0914 8.30713 33.7937 12.573 23.7193 13.8152C21.9668 14.0317 20.4371 14.1202 19.1064 14.1202C13.1159 14.1202 11.1661 12.3255 11.1661 12.3255C11.1661 12.3255 5.34466 45.3756 38.0914 63.5377C70.8359 45.3755 65.0145 12.3255 65.0145 12.3255C65.0145 12.3255 63.0658 14.1202 57.0742 14.1202C55.7438 14.1202 54.2132 14.0316 52.4613 13.8152C42.3885 12.573 38.0914 8.30713 38.0914 8.30713Z",
    fill: "url(#paint48_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9933 22.7937L34.1137 38.9382L27.4313 32.5466L22.7891 36.9863L34.1137 47.8177L55.6351 27.2337L50.9933 22.7937Z",
    fill: "url(#paint49_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5247 15.0676C41.4677 16.6781 45.9315 18.4543 52.11 19.2162C54.0076 19.4505 55.8237 19.5694 57.5078 19.5694C58.276 19.5694 59.0012 19.5451 59.6863 19.5004C59.5867 22.3443 59.2054 25.9037 58.1958 29.7757C55.3084 40.8487 48.6982 49.7319 38.5249 56.226C28.3507 49.7319 21.7398 40.8486 18.8522 29.7756C17.8425 25.9037 17.4612 22.3442 17.3615 19.5004C18.0464 19.5451 18.7719 19.5694 19.54 19.5694C21.2239 19.5694 23.04 19.4505 24.9364 19.2163C31.1169 18.4543 35.5812 16.6782 38.5247 15.0676ZM38.525 7.89526C38.525 7.89526 34.2273 12.1612 24.1529 13.4034C22.4004 13.6198 20.8707 13.7083 19.54 13.7083C13.5495 13.7083 11.5997 11.9137 11.5997 11.9137C11.5997 11.9137 5.77821 44.9638 38.525 63.1259C71.2695 44.9637 65.4481 11.9137 65.4481 11.9137C65.4481 11.9137 63.4994 13.7083 57.5078 13.7083C56.1774 13.7083 54.6468 13.6197 52.8949 13.4034C42.822 12.1612 38.525 7.89526 38.525 7.89526Z",
    fill: "url(#paint50_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4268 22.3818L34.5474 38.5263L27.8649 32.1347L23.2227 36.5744L34.5474 47.4058L56.0687 26.8219L51.4268 22.3818Z",
    fill: "url(#paint51_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9544 14.6558C41.8974 16.2663 46.3612 18.0424 52.5398 18.8044C54.4374 19.0387 56.2534 19.1576 57.9375 19.1576C58.7057 19.1576 59.431 19.1333 60.1161 19.0886C60.0164 21.9325 59.6352 25.4919 58.6255 29.3639C55.7381 40.4369 49.128 49.3201 38.9546 55.8142C28.7805 49.3201 22.1696 40.4368 19.2819 29.3638C18.2722 25.4919 17.8909 21.9324 17.7912 19.0886C18.4761 19.1333 19.2016 19.1576 19.9697 19.1576C21.6537 19.1576 23.4697 19.0387 25.3662 18.8045C31.5466 18.0425 36.011 16.2663 38.9544 14.6558ZM38.9547 7.4834C38.9547 7.4834 34.6569 11.7493 24.5826 12.9915C22.8301 13.2079 21.3004 13.2964 19.9696 13.2964C13.9792 13.2964 12.0294 11.5018 12.0294 11.5018C12.0294 11.5018 6.20789 44.5518 38.9547 62.714C71.6992 44.5518 65.8778 11.5018 65.8778 11.5018C65.8778 11.5018 63.9291 13.2964 57.9375 13.2964C56.6071 13.2964 55.0764 13.2079 53.3245 12.9915C43.2517 11.7493 38.9547 7.4834 38.9547 7.4834Z",
    fill: "url(#paint52_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8565 21.97L34.977 38.1145L28.2946 31.7229L23.6523 36.1626L34.977 46.994L56.4984 26.4101L51.8565 21.97Z",
    fill: "url(#paint53_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3841 14.2439C42.3271 15.8544 46.7909 17.6306 52.9695 18.3926C54.8671 18.6269 56.6832 18.7457 58.3673 18.7457C59.1355 18.7457 59.8607 18.7215 60.5458 18.6767C60.4461 21.5206 60.0649 25.0801 59.0553 28.952C56.1678 40.025 49.5577 48.9082 39.3844 55.4024C29.2102 48.9082 22.5993 40.0249 19.7117 28.9519C18.7019 25.08 18.3207 21.5206 18.221 18.6767C18.9058 18.7214 19.6313 18.7457 20.3994 18.7457C22.0834 18.7457 23.8995 18.6269 25.7959 18.3927C31.9763 17.6306 36.4406 15.8544 39.3841 14.2439ZM39.3844 7.07153C39.3844 7.07153 35.0866 11.3374 25.0122 12.5796C23.2598 12.7961 21.7301 12.8846 20.3993 12.8846C14.4089 12.8846 12.4591 11.09 12.4591 11.09C12.4591 11.09 6.63763 44.14 39.3844 62.3022C72.1288 44.14 66.3074 11.09 66.3074 11.09C66.3074 11.09 64.3588 12.8846 58.3672 12.8846C57.0368 12.8846 55.5061 12.796 53.7542 12.5796C43.6814 11.3374 39.3844 7.07153 39.3844 7.07153Z",
    fill: "url(#paint54_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2862 21.5581L35.4067 37.7026L28.7243 31.311L24.082 35.7507L35.4067 46.5821L56.9281 25.9982L52.2862 21.5581Z",
    fill: "url(#paint55_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8138 13.832C42.7568 15.4425 47.2206 17.2187 53.3992 17.9806C55.2968 18.2149 57.1128 18.3338 58.7969 18.3338C59.5652 18.3338 60.2904 18.3095 60.9755 18.2648C60.8758 21.1087 60.4946 24.6681 59.4849 28.5401C56.5976 39.6131 49.9874 48.4963 39.814 54.9904C29.6399 48.4963 23.029 39.613 20.1414 28.54C19.1316 24.6681 18.7504 21.1086 18.6506 18.2648C19.3355 18.3095 20.061 18.3338 20.8291 18.3338C22.5131 18.3338 24.3291 18.2149 26.2256 17.9808C32.406 17.2187 36.8703 15.4426 39.8138 13.832ZM39.8141 6.65967C39.8141 6.65967 35.5163 10.9256 25.4419 12.1678C23.6894 12.3842 22.1597 12.4727 20.829 12.4727C14.8385 12.4727 12.8888 10.6781 12.8888 10.6781C12.8888 10.6781 7.06732 43.7281 39.8141 61.8902C72.5585 43.728 66.7371 10.6781 66.7371 10.6781C66.7371 10.6781 64.7884 12.4727 58.7969 12.4727C57.4664 12.4727 55.9358 12.3841 54.1839 12.1678C44.1111 10.9256 39.8141 6.65967 39.8141 6.65967Z",
    fill: "url(#paint56_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7159 21.1462L35.8364 37.2907L29.154 30.8991L24.5117 35.3388L35.8364 46.1702L57.3578 25.5863L52.7159 21.1462Z",
    fill: "url(#paint57_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2474 13.4199C43.1904 15.0304 47.6542 16.8066 53.8327 17.5685C55.7303 17.8028 57.5464 17.9217 59.2305 17.9217C59.9987 17.9217 60.7239 17.8974 61.409 17.8527C61.3094 20.6966 60.9282 24.256 59.9185 28.128C57.0311 39.201 50.4209 48.0842 40.2476 54.5783C30.0734 48.0842 23.4625 39.2009 20.5749 28.1279C19.5652 24.256 19.1839 20.6965 19.0842 17.8527C19.7691 17.8974 20.4946 17.9217 21.2626 17.9217C22.9467 17.9217 24.7626 17.8028 26.6591 17.5686C32.8396 16.8066 37.3039 15.0305 40.2474 13.4199ZM40.2477 6.24756C40.2477 6.24756 35.9498 10.5135 25.8755 11.7557C24.123 11.9721 22.5933 12.0606 21.2626 12.0606C15.2721 12.0606 13.3224 10.266 13.3224 10.266C13.3224 10.266 7.50091 43.316 40.2477 61.4781C72.9921 43.3159 67.1707 10.266 67.1707 10.266C67.1707 10.266 65.222 12.0606 59.2305 12.0606C57.9 12.0606 56.3694 11.972 54.6175 11.7557C44.5447 10.5134 40.2477 6.24756 40.2477 6.24756Z",
    fill: "url(#paint58_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1495 20.7341L36.27 36.8786L29.5876 30.487L24.9453 34.9267L36.27 45.7581L57.7913 25.1742L53.1495 20.7341Z",
    fill: "url(#paint59_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.677 13.0081C43.6201 14.6185 48.0839 16.3947 54.2624 17.1567C56.16 17.391 57.976 17.5099 59.6601 17.5099C60.4283 17.5099 61.1536 17.4857 61.8386 17.4409C61.739 20.2848 61.3578 23.8443 60.3481 27.7162C57.4608 38.7892 50.8506 47.6724 40.6772 54.1665C30.503 47.6724 23.8922 38.7891 21.0045 27.716C19.9948 23.8442 19.6135 20.2847 19.5138 17.4409C20.1987 17.4856 20.9242 17.5099 21.6923 17.5099C23.3763 17.5099 25.1923 17.391 27.0888 17.1568C33.2692 16.3948 37.7336 14.6186 40.677 13.0081ZM40.6774 5.83569C40.6774 5.83569 36.3796 10.1016 26.3052 11.3438C24.5527 11.5602 23.023 11.6487 21.6923 11.6487C15.7018 11.6487 13.7521 9.8541 13.7521 9.8541C13.7521 9.8541 7.9306 42.9041 40.6774 61.0663C73.4218 42.9041 67.6004 9.8541 67.6004 9.8541C67.6004 9.8541 65.6517 11.6487 59.6602 11.6487C58.3297 11.6487 56.7991 11.5602 55.0472 11.3438C44.9744 10.1016 40.6774 5.83569 40.6774 5.83569Z",
    fill: "url(#paint60_linear_2725_1850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5792 20.3223L36.6997 36.4667L30.0173 30.0752L25.375 34.5148L36.6997 45.3462L58.221 24.7623L53.5792 20.3223Z",
    fill: "url(#paint61_linear_2725_1850)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.677 13.0081C43.6201 14.6185 48.0839 16.3947 54.2624 17.1567C56.16 17.391 57.976 17.5099 59.6601 17.5099C60.4283 17.5099 61.1536 17.4857 61.8386 17.4409C61.739 20.2848 61.3578 23.8443 60.3481 27.7162C57.4608 38.7892 50.8506 47.6724 40.6772 54.1665C30.503 47.6724 23.8922 38.7891 21.0045 27.716C19.9948 23.8442 19.6135 20.2847 19.5138 17.4409C20.1987 17.4856 20.9242 17.5099 21.6923 17.5099C23.3763 17.5099 25.1923 17.391 27.0888 17.1568C33.2692 16.3948 37.7336 14.6186 40.677 13.0081ZM40.6774 5.83569C40.6774 5.83569 36.3796 10.1016 26.3052 11.3438C24.5527 11.5602 23.023 11.6487 21.6923 11.6487C15.7018 11.6487 13.7521 9.8541 13.7521 9.8541C13.7521 9.8541 7.9306 42.9041 40.6774 61.0663C73.4218 42.9041 67.6004 9.8541 67.6004 9.8541C67.6004 9.8541 65.6517 11.6487 59.6602 11.6487C58.3297 11.6487 56.7991 11.5602 55.0472 11.3438C44.9744 10.1016 40.6774 5.83569 40.6774 5.83569Z",
    fill: "url(#paint62_linear_2725_1850)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5792 20.3223L36.6997 36.4667L30.0173 30.0752L25.375 34.5148L36.6997 45.3462L58.221 24.7623L53.5792 20.3223Z",
    fill: "url(#paint63_linear_2725_1850)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2725_1850",
    x1: 5.56564,
    y1: 57.5312,
    x2: 47.3651,
    y2: 13.8282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#F9FDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFEF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2725_1850",
    x1: 9.1005,
    y1: 60.9104,
    x2: 50.9001,
    y2: 17.2072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#F9FDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFEF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2725_1850",
    x1: 5.99534,
    y1: 57.1193,
    x2: 47.7948,
    y2: 13.4163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#F4FAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FDF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2725_1850",
    x1: 9.5302,
    y1: 60.4985,
    x2: 51.3298,
    y2: 16.7954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#F4FAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FDF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2725_1850",
    x1: 6.42895,
    y1: 56.7075,
    x2: 48.2284,
    y2: 13.0045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#EEF8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5FCEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2725_1850",
    x1: 9.96375,
    y1: 60.0866,
    x2: 51.7633,
    y2: 16.3835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#EEF8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5FCEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2725_1850",
    x1: 6.85853,
    y1: 56.2956,
    x2: 48.658,
    y2: 12.5926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0F1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#E9F6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FBE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2725_1850",
    x1: 10.3935,
    y1: 59.6747,
    x2: 52.193,
    y2: 15.9716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0F1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#E9F6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FBE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2725_1850",
    x1: 7.28829,
    y1: 55.8835,
    x2: 49.0878,
    y2: 12.1805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8EED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#E3F4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#E6F5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2725_1850",
    x1: 10.8232,
    y1: 59.2626,
    x2: 52.6227,
    y2: 15.5595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8EED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#E3F4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#E6F5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2725_1850",
    x1: 7.72191,
    y1: 55.4716,
    x2: 49.5214,
    y2: 11.7686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1EACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#DDF1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5478,
    stopColor: "#E2F4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2725_1850",
    x1: 11.2568,
    y1: 58.8508,
    x2: 53.0563,
    y2: 15.1477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1EACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#DDF1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5478,
    stopColor: "#E2F4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2725_1850",
    x1: 8.15154,
    y1: 55.0598,
    x2: 49.951,
    y2: 11.3567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9E7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#D8EFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5904,
    stopColor: "#DFF3CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2725_1850",
    x1: 11.6865,
    y1: 58.4389,
    x2: 53.4861,
    y2: 14.7358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9E7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#D8EFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5904,
    stopColor: "#DFF3CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2725_1850",
    x1: 8.58125,
    y1: 54.6479,
    x2: 50.3807,
    y2: 10.9449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E4BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#D2EDC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6394,
    stopColor: "#DCF2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F7C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2725_1850",
    x1: 12.1161,
    y1: 58.027,
    x2: 53.9157,
    y2: 14.3239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E4BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#D2EDC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6394,
    stopColor: "#DCF2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F7C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2725_1850",
    x1: 9.01095,
    y1: 54.2358,
    x2: 50.8104,
    y2: 10.5328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAE0B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#CCEABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6765,
    stopColor: "#D9F1BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F6C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2725_1850",
    x1: 12.5458,
    y1: 57.615,
    x2: 54.3454,
    y2: 13.9118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAE0B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#CCEABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6765,
    stopColor: "#D9F1BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F6C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2725_1850",
    x1: 9.44451,
    y1: 53.8239,
    x2: 51.244,
    y2: 10.1209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DDAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#C7E8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#D5F0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEF5B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2725_1850",
    x1: 12.9794,
    y1: 57.2031,
    x2: 54.779,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DDAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#C7E8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#D5F0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEF5B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2725_1850",
    x1: 9.87426,
    y1: 53.412,
    x2: 51.6737,
    y2: 9.70906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAD9A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#C1E6AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7139,
    stopColor: "#D2EFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBF4B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2725_1850",
    x1: 13.4091,
    y1: 56.7912,
    x2: 55.2086,
    y2: 13.0881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAD9A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#C1E6AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7139,
    stopColor: "#D2EFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBF4B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2725_1850",
    x1: 10.304,
    y1: 53.0002,
    x2: 52.1034,
    y2: 9.29716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2D69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#BCE4A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7292,
    stopColor: "#CFEEA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8F3AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2725_1850",
    x1: 13.8388,
    y1: 56.3793,
    x2: 55.6383,
    y2: 12.6762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2D69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#BCE4A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7292,
    stopColor: "#CFEEA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8F3AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2725_1850",
    x1: 10.7337,
    y1: 52.5883,
    x2: 52.5331,
    y2: 8.88529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BD394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#B6E19C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7488,
    stopColor: "#CCEDA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5F2A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2725_1850",
    x1: 14.2685,
    y1: 55.9672,
    x2: 56.068,
    y2: 12.2641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BD394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#B6E19C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7488,
    stopColor: "#CCEDA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5F2A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2725_1850",
    x1: 11.1672,
    y1: 52.1762,
    x2: 52.9667,
    y2: 8.47322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CF8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#B0DF94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7602,
    stopColor: "#C8EC9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1F19D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2725_1850",
    x1: 14.7021,
    y1: 55.5554,
    x2: 56.5017,
    y2: 11.8523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CF8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#B0DF94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7602,
    stopColor: "#C8EC9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1F19D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2725_1850",
    x1: 11.5969,
    y1: 51.7643,
    x2: 53.3964,
    y2: 8.06134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BCC84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#ABDD8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3943,
    stopColor: "#ACDE8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7704,
    stopColor: "#C5EB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEF096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2725_1850",
    x1: 15.1318,
    y1: 55.1435,
    x2: 56.9314,
    y2: 11.4404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BCC84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#ABDD8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3943,
    stopColor: "#ACDE8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7704,
    stopColor: "#C5EB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEF096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2725_1850",
    x1: 12.0266,
    y1: 51.3525,
    x2: 53.8261,
    y2: 7.64946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#A5DA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4302,
    stopColor: "#A9DC86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#C2E98D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBEE8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2725_1850",
    x1: 15.5614,
    y1: 54.7316,
    x2: 57.361,
    y2: 11.0285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#A5DA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4302,
    stopColor: "#A9DC86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#C2E98D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBEE8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2725_1850",
    x1: 12.4563,
    y1: 50.9406,
    x2: 54.2558,
    y2: 7.23758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CC573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#A0D87D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4514,
    stopColor: "#A6DB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#BFE885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8ED88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2725_1850",
    x1: 15.9911,
    y1: 54.3197,
    x2: 57.7907,
    y2: 10.6166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CC573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#A0D87D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4514,
    stopColor: "#A6DB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#BFE885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8ED88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2725_1850",
    x1: 12.8899,
    y1: 50.5288,
    x2: 54.6893,
    y2: 6.82576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#9AD675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4709,
    stopColor: "#A2DA77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7994,
    stopColor: "#BBE77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4EC81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2725_1850",
    x1: 16.4247,
    y1: 53.9079,
    x2: 58.2243,
    y2: 10.2048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#9AD675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4709,
    stopColor: "#A2DA77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7994,
    stopColor: "#BBE77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4EC81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2725_1850",
    x1: 13.3196,
    y1: 50.1166,
    x2: 55.119,
    y2: 6.41364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DBE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#94D36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4973,
    stopColor: "#9FD971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8094,
    stopColor: "#B8E678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1EB7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2725_1850",
    x1: 16.8544,
    y1: 53.4958,
    x2: 58.654,
    y2: 9.79269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DBE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#94D36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4973,
    stopColor: "#9FD971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8094,
    stopColor: "#B8E678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1EB7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2725_1850",
    x1: 13.7493,
    y1: 49.7048,
    x2: 55.5487,
    y2: 6.00176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65BB5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#8FD166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5132,
    stopColor: "#9CD86A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8154,
    stopColor: "#B5E570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2725_1850",
    x1: 17.2841,
    y1: 53.0839,
    x2: 59.0836,
    y2: 9.38081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65BB5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#8FD166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5132,
    stopColor: "#9CD86A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8154,
    stopColor: "#B5E570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2725_1850",
    x1: 14.179,
    y1: 49.2929,
    x2: 55.9784,
    y2: 5.58988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DB752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#89CF5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#99D763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8237,
    stopColor: "#B2E469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBE96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2725_1850",
    x1: 17.7138,
    y1: 52.672,
    x2: 59.5134,
    y2: 8.96893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DB752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#89CF5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#99D763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8237,
    stopColor: "#B2E469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBE96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2725_1850",
    x1: 14.6125,
    y1: 48.881,
    x2: 56.412,
    y2: 5.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55B44A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#56B54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#84CD57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5418,
    stopColor: "#95D65C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8262,
    stopColor: "#AEE362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7E865"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2725_1850",
    x1: 18.1474,
    y1: 52.26,
    x2: 59.947,
    y2: 8.55686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55B44A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#56B54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#84CD57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5418,
    stopColor: "#95D65C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8262,
    stopColor: "#AEE362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7E865"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2725_1850",
    x1: 15.0422,
    y1: 48.4692,
    x2: 56.8417,
    y2: 4.76618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EB042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0173,
    stopColor: "#50B143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#7ECA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5608,
    stopColor: "#92D555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8334,
    stopColor: "#ABE25B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4E75E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2725_1850",
    x1: 18.5771,
    y1: 51.8483,
    x2: 60.3767,
    y2: 8.14524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EB042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0173,
    stopColor: "#50B143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#7ECA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5608,
    stopColor: "#92D555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8334,
    stopColor: "#ABE25B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4E75E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2725_1850",
    x1: 15.4719,
    y1: 48.0571,
    x2: 57.2714,
    y2: 4.35406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46AD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0309,
    stopColor: "#4AAF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#78C848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    stopColor: "#8FD44E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A8E155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1E657"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2725_1850",
    x1: 19.0067,
    y1: 51.4362,
    x2: 60.8063,
    y2: 7.7331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46AD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0309,
    stopColor: "#4AAF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#78C848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    stopColor: "#8FD44E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A8E155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1E657"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2725_1850",
    x1: 15.9016,
    y1: 47.6452,
    x2: 57.7011,
    y2: 3.94217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EAA31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#45AE33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#73C640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5888,
    stopColor: "#8CD347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#A5E04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEE550"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2725_1850",
    x1: 19.4364,
    y1: 51.0243,
    x2: 61.236,
    y2: 7.32123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EAA31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#45AE33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#73C640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5888,
    stopColor: "#8CD347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#A5E04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEE550"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2725_1850",
    x1: 16.3352,
    y1: 47.2333,
    x2: 58.1346,
    y2: 3.5303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37A629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0552,
    stopColor: "#3FAA2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#6DC338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5988,
    stopColor: "#88D240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#A1DF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAE449"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2725_1850",
    x1: 19.87,
    y1: 50.6124,
    x2: 61.6696,
    y2: 6.90934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37A629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0552,
    stopColor: "#3FAA2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#6DC338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5988,
    stopColor: "#88D240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#A1DF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAE449"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2725_1850",
    x1: 16.7649,
    y1: 46.8215,
    x2: 58.5643,
    y2: 3.11847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FA321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0661,
    stopColor: "#39A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#67C131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6128,
    stopColor: "#85D139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8531,
    stopColor: "#9EDE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7E342"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2725_1850",
    x1: 20.2997,
    y1: 50.2006,
    x2: 62.0993,
    y2: 6.49753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FA321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0661,
    stopColor: "#39A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#67C131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6128,
    stopColor: "#85D139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8531,
    stopColor: "#9EDE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7E342"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2725_1850",
    x1: 17.1946,
    y1: 46.4096,
    x2: 58.994,
    y2: 2.70659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#279F19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    stopColor: "#34A61D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#62BF29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6207,
    stopColor: "#82D032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8564,
    stopColor: "#9BDD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4E23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2725_1850",
    x1: 20.7294,
    y1: 49.7887,
    x2: 62.5289,
    y2: 6.08565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#279F19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    stopColor: "#34A61D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#62BF29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6207,
    stopColor: "#82D032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8564,
    stopColor: "#9BDD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4E23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2725_1850",
    x1: 17.6243,
    y1: 45.9977,
    x2: 59.4237,
    y2: 2.29471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F9C10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0902,
    stopColor: "#2EA414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#5CBD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#7FCF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8611,
    stopColor: "#98DC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1E134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2725_1850",
    x1: 21.1591,
    y1: 49.3768,
    x2: 62.9587,
    y2: 5.67377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F9C10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0902,
    stopColor: "#2EA414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#5CBD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#7FCF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8611,
    stopColor: "#98DC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1E134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2725_1850",
    x1: 18.0579,
    y1: 45.5856,
    x2: 59.8573,
    y2: 1.88259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#189808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0988,
    stopColor: "#29A10D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#57BA1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6369,
    stopColor: "#7BCE24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    stopColor: "#94DB2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE02D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2725_1850",
    x1: 21.5927,
    y1: 48.9647,
    x2: 63.3923,
    y2: 5.26165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#189808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0988,
    stopColor: "#29A10D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#57BA1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6369,
    stopColor: "#7BCE24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    stopColor: "#94DB2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE02D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2725_1850",
    x1: 18.4875,
    y1: 45.1738,
    x2: 60.287,
    y2: 1.47077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1069,
    stopColor: "#239F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#51B812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    stopColor: "#78CD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    stopColor: "#91DA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ADF26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2725_1850",
    x1: 22.0224,
    y1: 48.5528,
    x2: 63.822,
    y2: 4.84978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1069,
    stopColor: "#239F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#51B812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    stopColor: "#78CD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    stopColor: "#91DA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ADF26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2725_1850",
    x1: 18.4875,
    y1: 45.1738,
    x2: 60.287,
    y2: 1.47077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1069,
    stopColor: "#239F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#51B812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    stopColor: "#78CD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    stopColor: "#91DA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ADF26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2725_1850",
    x1: 22.0224,
    y1: 48.5528,
    x2: 63.822,
    y2: 4.84978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1069,
    stopColor: "#239F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#51B812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    stopColor: "#78CD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    stopColor: "#91DA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ADF26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/icon-shield.85b0d4d8e5f6129739f93557c48dc052.svg";
export { ForwardRef as ReactComponent };